<template>
    <div>
        <label>{{ i18n("voucherDesign.predefinedImages") }}:</label>
        <div v-if="locationDetail">
            <button
                v-for="image in predefinedImages"
                type="button"
                :key="image.name"
                @mousedown="onMouseDown"
                @click="insertImageVariable(image)"
                class="btn btn-sm btn-outline-success m-1"
            >
                {{ image.label }}
                <strong v-if="image.required" class="text-danger">*</strong>
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { ILocationDetail } from "@/data/model/Location";
    import { i18n } from "@/portal/Trans";
    import {
        insertContentAtCursor,
        isInsideAbsoluteTextBox,
    } from "@/portal/components/vouchers/editor/helpers/editorUtils";
    import type { Editor } from "@tiptap/vue-3";
    import { type Ref, computed, inject, ref } from "vue";

    import { addAbsoluteTextBoxWithContent } from "../extensions/AbsoluteTextBox";

    const props = defineProps<{
        editor: Editor;
        locationDetail: ILocationDetail | undefined;
    }>();

    const locationLogo = computed(() => props.locationDetail?.design.originalLogoLightPath ?? "");
    const isFocusRecentlyLost = inject<Ref<boolean>>("isFocusRecentlyLost");
    const wasFocusRecentlyLostOnMouseDown = ref<boolean>(false);

    const predefinedImages = [
        {
            name: "QrCode",
            label: i18n("voucherDesign.qrCode"),
            src: "/assets/img/portal/qr_code_example.png",
            width: "200px",
            height: "200px",
            required: true,
        },
        {
            name: "LightLogo",
            label: i18n("voucherDesign.logo"),
            src: locationLogo.value,
            width: "auto",
            height: "auto",
        },
    ];

    function insertImageVariable(image: { name: string; label: string; src: string; width: string; height: string }) {
        console.log("insertImageVariable - wasFocusRecentlyLostOnMouseDown", wasFocusRecentlyLostOnMouseDown.value);
        const variableContent = {
            type: "documentImageVariable",
            attrs: {
                name: image.name,
                label: image.label,
                src: image.src,
                alt: image.label,
                width: image.width,
                height: image.height,
            },
        };

        if (isInsideAbsoluteTextBox(props.editor) && wasFocusRecentlyLostOnMouseDown?.value) {
            console.log("documentImageVariable to absolute text box", image);
            insertContentAtCursor(props.editor, variableContent);
        } else {
            console.log("documentImageVariable to document", image);
            addAbsoluteTextBoxWithContent(props.editor, [
                {
                    type: "paragraph",
                    content: [variableContent],
                },
            ]);
        }
        wasFocusRecentlyLostOnMouseDown.value = false;
    }

    function getRequiredImages() {
        return predefinedImages.filter((image) => image.required).map((image) => image.name);
    }

    function onMouseDown() {
        window.setTimeout(() => {
            console.log("onMouseDown", isFocusRecentlyLost?.value);
            wasFocusRecentlyLostOnMouseDown.value = isFocusRecentlyLost?.value ?? false;
        }, 30);
    }

    defineExpose({
        getRequiredImages,
    });
</script>
